import { subTopicSupport, typesSupportOccorence, typeSubjectOccorence } from "../constants";
import { IOccurrence } from "../types";
import Chip from "./Chip";
import moment from "moment";

interface Props {
    onClick: () => void;
    data: IOccurrence;
    disabled?: boolean;
}

export const convertMinutesToHours = (minutes?: number) => {
    if (!minutes) {
        return '-'
    };

    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;

    if (hours === 0) {
        return `${mins} min`;
    }

    if (mins === 0) {
        return `${hours} h`;
    }

    return `${hours}h ${mins}min`;
};

const BoardItem = ({ onClick, data, disabled }: Props) => {
    return (
        <div className={`bg-white flex-1-1 border rounded rounded-small padding-10 ${disabled ? '' : 'cursor-pointer'} height-lg-300`} style={{ borderColor: '#344054', height: 250 }} onClick={() => disabled ? null : onClick()}>
            <div className="border border-bottom-only" style={{ paddingBottom: 8 }}>
                <div className="display-flex">
                    <span className="text-medium text-size-14 width-50pct">{data?.tasOccurrenceNumber || '-'}</span>
                    <span className="text-size-14 width-50pct text-right">{data?.licensePlate || '-'}</span>
                </div>

                {/* <span className="text-size-14 width-50pct">{data?.customer?.toUpperCase() || '-'}</span> */}
                <span className="text-size-14">{data?.dn || '-'}</span>
            </div>
            <div className="display-flex gap-4" style={{ paddingTop: 8 }}>
                <div className="width-50pct border rounded" style={{ padding: 8 }}>
                    <div><Chip type={data?.supportType} /></div>
                    <div className="margin-top-4 display-grid">
                        <span className="text-size-12 text-medium" style={{ color: '#344054' }}>Assunto:</span>
                        <span className="text-size-12 text-normal">
                            {typeSubjectOccorence[data?.subject?.toUpperCase() as keyof typeof typeSubjectOccorence] || '-'}
                        </span>
                    </div>
                    {data.supportType === 'TECHNICAL_SUPPORT' ? null : (
                        <div className="margin-top-4 border border-top-only display-grid">
                            <span className="text-size-12 text-medium" style={{ color: '#344054' }}>Tema:</span>
                            <span className="text-size-12 text-normal">{subTopicSupport[data.subtopic as keyof typeof subTopicSupport]}</span>
                        </div>
                    )}
                </div>
                <div className="width-50pct rounded" style={{ background: 'rgba(2, 106, 162, 0.04)', padding: 8 }} >
                    <div className="border border-bottom-only display-grid padding-bottom-4">
                        <span className="text-size-12 text-medium" style={{ color: '#344054' }}>Proprietário:</span>
                        <span className="text-size-12 text-normal">{data?.responsible || '-'}</span>
                    </div>
                    <div className="border border-bottom-only display-grid padding-y-4">
                        <span className="text-size-12 text-medium" style={{ color: '#344054' }}>Atribuído á</span>
                        <span className="text-size-12 text-normal">{data.assignedTo || '-'}</span>
                    </div>
                    <div className="border border-bottom-only display-grid padding-y-4">
                        <span className="text-size-12 text-normal">
                        {data.status === 'FINISHED' ?
                            data?.timeInTasOccurrence ? `${convertMinutesToHours(data?.timeInTasOccurrence)} neste chamado` : '-' :
                            data?.timeInStatus ? `${convertMinutesToHours(data?.timeInStatus)} nesta etapa` : '-'
                        }
                        </span>
                    </div>
                    <div className="display-flex margin-top-4 gap-0">
                        <span className="text-size-12 text-medium" style={{ color: '#344054' }}>Criação: </span>
                        <span className="text-size-12 text-normal margin-left-4">{data?.createdAt ? moment(data?.createdAt).format("DD/MM/YYYY HH:mm") : '-'}</span>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default BoardItem;